import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { getUserPoints } from "../services/pointsService";
import "../css/Cart.css";

function VideoBg() {
  return (
    <>
      <video
        autoPlay muted loop playsInline
        style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
                 objectFit: "cover", zIndex: -2 }}
      >
        <source src="/videos/PavilionVid.mp4" type="video/mp4" />
      </video>
      <div style={{ position: "fixed", inset: 0, zIndex: -1,
                    background: "linear-gradient(to bottom, rgba(4,8,25,0.78) 0%, rgba(8,14,40,0.7) 100%)" }} />
    </>
  );
}

export default function BookingConfirmed() {
  const { currentUser } = useAuth();
  const location = useLocation();

  const {
    pointsAwarded = null,
    totalCharged  = null,
    bookingCount  = 1,
    newBalance: stateBalance = null,
  } = location.state || {};

  const [currentBalance, setCurrentBalance] = useState(stateBalance);
  const [balanceLoaded, setBalanceLoaded]   = useState(stateBalance != null);
  const [balanceError, setBalanceError]     = useState(false);

  useEffect(() => {
    if (!currentUser) return;
    let cancelled = false;

    getUserPoints(currentUser.uid)
      .then((data) => {
        if (!cancelled) {
          setCurrentBalance(data?.currentPoints ?? 0);
          setBalanceLoaded(true);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setBalanceError(true);
          setBalanceLoaded(true);
        }
      });

    return () => { cancelled = true; };
  }, [currentUser]);

  const count     = bookingCount || 1;
  const isPlural  = count > 1;
  const heading   = isPlural ? "Bookings Confirmed!" : "Booking Confirmed!";
  const subtext   = isPlural
    ? `All ${count} reservations have been confirmed and saved to your account.`
    : "Your reservation has been confirmed and saved to your account.";

  const showPoints = pointsAwarded != null && pointsAwarded > 0;

  return (
    <div className="cart-page-wrapper">
      <VideoBg />
      <div className="cart-content">
        <div className="cart-success-page">
          <div className="cart-success-icon">🎉</div>
          <h2>{heading}</h2>
          <p className="cart-success-msg">{subtext}</p>

          {showPoints && (
            <div className="cart-success-points">
              +{pointsAwarded.toLocaleString()} reward point{pointsAwarded === 1 ? "" : "s"} earned
            </div>
          )}

          {/* Current balance — authoritative from Firestore */}
          {!balanceError && (
            <p className="cart-success-balance">
              {currentBalance != null
                ? `Current balance: ${currentBalance.toLocaleString()} point${currentBalance === 1 ? "" : "s"}`
                : "Loading your balance…"}
            </p>
          )}
          {balanceError && (
            <p className="cart-success-balance cart-success-balance--error">
              Balance temporarily unavailable — check your{" "}
              <Link to="/points" style={{ color: "inherit", textDecoration: "underline" }}>
                Rewards page
              </Link>
              .
            </p>
          )}

          {totalCharged != null && totalCharged > 0 && (
            <p className="cart-success-total">
              Total charged:{" "}
              <strong>
                {totalCharged.toLocaleString("en-US", { style: "currency", currency: "USD" })}
              </strong>
            </p>
          )}

          <div className="cart-success-actions">
            <Link to="/points" className="cart-empty-link">View My Rewards</Link>
            <Link to="/" className="cart-empty-link">Return Home</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
